import { Route, Routes } from "react-router-dom";
import C7Positions from "./C7Positions/main";
import { Tables } from "@/gen/tableNames/tables";

export default function C7Routes() {
  return (
    <Routes>
      <Route path={`${Tables.C7_POSITIONS}/*`} element={<C7Positions />} />
    </Routes>
  );
}
